<div class="preview" [attr.data-testid]="'template-preview-container'">
  <ng-content></ng-content>
  <mat-progress-bar
    [attr.data-testid]="'template-preview-progress-bar'"
    [style.opacity]="countdown ? 1 : 0"
    mode="determinate"
    [value]="countdown"
  >
  </mat-progress-bar>
</div>
